import React from 'react';
import { getHiddenTicket } from '../../../data/utils';
import { getLabel } from '../../../InitData';

function BorderedTicketHeader(props) {
	
	const ticketData = props.ticketData;
	const conf = props.conf;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; 
	const terminalCopy = props.terminalCopy;
	const skinProperties = props.skinProperties;
	
	const logoBottom = conf.tad && conf.tad.lob;
	const imgBase64CustomerLogo = logoBottom? null : props.customerLogo;
	
	const ticketOnHeader = conf.tad && conf.tad.idh;

	function generateIdTicketWithBars(idTicket){
		let idTicketToShow = idTicket;
		if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
			idTicketToShow = getHiddenTicket(idTicketToShow);
		}
		let res = '';
		let tokens = idTicketToShow.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}
	let lastCharReprint = '';
	if(props.printAgainTerminalRec){
		let label = getLabel('printer.bordered_ticket.footer.id');
		lastCharReprint = label.substr(label.length - 1);
	}
	return <>
	{
		frontendType === 'ONLINE' && aamsEnviroment && <>
			<div className="text-container bold font-size10">
				PROMEMORIA SCOMMESSA TELEMATICA
			</div>
			<div className="text-container font-size10">
				Agenzia delle Dogane e dei Monopoli
			</div>
		</>
		
	}
	<div className="customer-logo-container">
		{
			imgBase64CustomerLogo != null && imgBase64CustomerLogo.length > 0 && (
					<img src={imgBase64CustomerLogo} />
			)
		}
	</div>
	{
		aamsEnviroment && <>
			<div className="text-container">
				Concessione n. {ticketData.cc}
			</div>
		
		</>
	}
	{
		frontendType === 'SELF-CASHIER' && (
				<div className="div-table">
					<div className="text-container">
						Cassa numero 0
					</div>
				</div>
		)
	}

	{
		ticketOnHeader && (
				<div className="div-table">
					<div className="metadata-row">
						<div className="metadata-key">{getLabel('printer.bordered_ticket.footer.id') + lastCharReprint.toUpperCase()}</div>
						<div className="metadata-value">{generateIdTicketWithBars(ticketData.idTicket)}</div>
						<div className="clear"></div>
					</div>
				</div>
		)
	}
	
	</>
}

export default BorderedTicketHeader;